import { render, staticRenderFns } from "./friend-list.vue?vue&type=template&id=2dcd70c3&"
import script from "./friend-list.vue?vue&type=script&lang=js&"
export * from "./friend-list.vue?vue&type=script&lang=js&"
import style0 from "./friend-list.vue?vue&type=style&index=0&lang=stylus&scpoed=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports